export const knownGraphQLErrors = [
    'AddressInvalid',
    'CreditCardFailedAuth',
    'RegistrationIsStudent',
    'RegistrationAccountInactive',
    'RegistrationAccountNotFound',
    'RegistrationInvalidChannel',
    'RegistrationIPAddressLockedOut',
    'SmsRmaAlreadyOpenForItems',
    'CheckoutInvalidShippingAddress',
    'CheckoutInvalidBillingAddress',
    'CheckoutInvalidShippingMethod',
    'CheckoutInvalidPaymentMethod',
    'CheckoutInvalidPaymentTerms',
    'CheckoutPaymentFailed'
];

/**
 *
 * @param pathName - Query field
 * @param error - ApolloError object
 * @returns {T[]|Array}
 */
export function getGraphQLErrorsByPathName( pathName, error ) {
    if ( !error || !error.graphQLErrors.length ) {
        return [];
    }

    return error.graphQLErrors.filter( ( {path} ) => Array.isArray( path ) && path.includes( pathName ) );
}

/**
 * Track current queued Mutations in order to properly handle merge strategy for optimisticResponses
 * @type {{addLineItems: Array, updateLineItems: Array, deleteLineItems: Array}}
 */
export const createQueueManager = ( mutationsList = [] ) => {
    const queue = mutationsList.reduce( ( acc, next ) => {
        acc[next] = [];
        return acc;
    }, {} );

    return {
        add: ( selection, lineItems ) => {
            if ( !queue[selection] ) {
                return lineItems;
            }
            return queue[selection] = queue[selection].concat( lineItems );
        },
        remove: ( selection, lineItems ) => {
            if ( !queue[selection] ) {
                return lineItems;
            }
            const removals = lineItems.map( i => i.product.sku );
            return queue[selection] = queue[selection].filter( i => !removals.includes( i.product.sku ) );
        }
    }
};
